import { PlatformLocationFeature } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/location_features.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaPlatformLocationFeatureV1Service = bindHTTP(PlatformLocationFeature);
export const serviceName = 'platform-location-feature-v1' as const;
